
import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import { useDispatch, useSelector } from "react-redux"
import { createRef, useEffect, useRef, useState } from "react"
import Pagination from "../../components/shared/Pagination"
import { getAdminCompanyLoadFilter, resetSingleShipmentLoadItem } from "../../features/loadList/loadListSlice"
import ItemContainer from "../../components/topList/tamamlananSeferlerList/item/ItemContainer"
import ItemWideContainer from "../../components/topList/tamamlananSeferlerList/item/ItemWideContainer"
import SmallSpinner from "../../components/shared/spinners/SmallSpinner"
import TopPagesMapTamamlanan from "../../components/topPagesMap/TopPagesMapTamamlanan"
import { resetAllState } from "../../features/topPagesMap/topPagesMapSlice"
import useWindowDimensions from "../../hooks/useWindowSize"
import ItemMobileContainer from "../../components/topList/tamamlananSeferlerList/item/ItemMobileContainer"
import TamamlananListTopContainer from "../../components/topPages/topContainer/TamamlananListTopContainer"
import InputSelectLoadListFilter from "../../components/shared/input/special/InputSelectLoadListFilter"
import CollapsibleTopMap from "../../components/topPages/CollapsibleTopMap"

const Container = styled.div`
    .wrapper{
        display: flex;
        flex-direction: column;
        width: 100%;

        .content{
            gap: 60px;
            margin: 0 30px;
            margin-top: 20px;
            .top-filter-admin{
                display: flex;
                align-items: center;
                justify-content: flex-end;
                width: 100%;
                margin-block: 20px;
            }
            .loading{
                min-height: 30vh;
                display: flex;
                align-items: center;
                justify-content: center;}
        }

        .pagination-container{
            gap: 60px;
            margin: 0 30px;
            margin-top: 20px;
            height: 200px;
        }
}
 
`
const TamamlananSeferlerList = () => {
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const rld = JSON.parse(storage.getItem("rld"))
    const {tamamlananSeferlerList, tamamlananSeferlerListQuantity,isLoadingTamamlananSeferlerList, loadItemSelect, selectedLoadListCompany, loadListCompanyList} = useSelector(state => state.loadList)

    const [activeItemId, setActiveItemId] = useState(null)
    const [currentPage, setCurrentPage] = useState(1)
    const [isMapOpen, setIsMapOpen] = useState(false)
    const {windowDimensions} = useWindowDimensions()


    const {locationListTamamlanan} = useSelector(state => state.topPagesMap)

    const dispatch = useDispatch()

    const itemsPerPage = 20
    const totalPages = Math.ceil(tamamlananSeferlerListQuantity / itemsPerPage);

    useEffect(() => {
        // Sayfa yüklendiğinde en üste kaydır
        window.scrollTo(0, 0);
    }, []);

    const elementRef = useRef(null);
    const itemRefs = useRef([]);
    useEffect(() => {
        itemRefs.current = tamamlananSeferlerList.map(() => createRef());
      }, [tamamlananSeferlerList]);

        useEffect(() => {
        const matchedItem = tamamlananSeferlerList.find(item => item.id === loadItemSelect);
        if (matchedItem) {
          const element = document.getElementById(matchedItem.id);
          if (element) {
            const navbarHeight = 255;
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      
            window.scrollTo({
              top: elementPosition - navbarHeight,
              behavior: "smooth"
            });
          }
         }
       }, [loadItemSelect, tamamlananSeferlerList]);


    const scrollToMiddle = (activeItemId) => {
        const matchedItem = tamamlananSeferlerList.find(item => item.id === activeItemId);
        if (matchedItem) {
          const element = document.getElementById(matchedItem.id);
           if (element) {
            elementRef.current = element; 
            elementRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
         }
        }

        useEffect(() => {
            if(rld === "db7bb061-0f64-4eae-9c4f-678a7359fd01" || rld === "f84f35ab-0eb1-46a4-84f4-e72b236c3d26" || rld === "a7b53ef7-1cf6-4720-9b13-d9f81b5a0f99"){
                dispatch(getAdminCompanyLoadFilter())
            }
          },[])

        useEffect(()=> {

            return () => {
                dispatch(resetAllState())
                dispatch(resetSingleShipmentLoadItem())
             }
    
           },[])

           
        return (
    <Container>
        <div className="wrapper">
            <PageTopTitle title={"Tamamlanan Seferler"} position="sticky"/>
            <div className="content">
                <CollapsibleTopMap isOpen={isMapOpen} onToggle={() => setIsMapOpen(open => !open)}>
                    <TopPagesMapTamamlanan locationList={locationListTamamlanan}/>
                </CollapsibleTopMap>
                {"db7bb061-0f64-4eae-9c4f-678a7359fd01" === rld &&
                    <div className="top-filter-admin">
                        <InputSelectLoadListFilter data={selectedLoadListCompany} labelText={"Firma Adı"} inputWidth={"300px"} initialOptions={loadListCompanyList} name={"selectedLoadListCompany"} />
                    </div>
                }
                <TamamlananListTopContainer currentPage={currentPage}/>
                {
                    isLoadingTamamlananSeferlerList 
                    ?
                        <div className="loading">
                            <SmallSpinner size={"65px"} color={"#fff"} bgColor={"#E85446"} />
                        </div>
                    :
                    <>
                        {tamamlananSeferlerList.map((item, i) => {
                            const width = windowDimensions?.width;
                            const isActive = item.id === activeItemId;

                            let ItemComponent;
                            if (width < 850) {
                                ItemComponent = ItemMobileContainer; 
                            } else if (width < 1150 || isActive) {
                                ItemComponent = ItemWideContainer;
                            } else {
                                ItemComponent = ItemContainer;
                            }
                            return (
                            <div >
                                <ItemComponent item={item} activeItemId={activeItemId} setActiveItemId={setActiveItemId} forwardRef={itemRefs.current[i]} handleClick={scrollToMiddle} onShowMap={() => setIsMapOpen(true)} />
                            </div>
                        )})}
                    </>
                }
            </div>
            <div className="pagination-container">
            {
                tamamlananSeferlerList.length > 0 &&   
                <Pagination totalPages={totalPages} handleClick={setCurrentPage} currentPage={currentPage}/>
            }
        </div>
        </div>
    </Container>
  )
}

export default TamamlananSeferlerList
